'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sitemap = require('sitemap');

var _sitemap2 = _interopRequireDefault(_sitemap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildSitemap = function buildSitemap() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http://localhost';
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return _sitemap2.default.createSitemap({
    hostname: hostname,
    urls: paths.map(function (item) {
      return { url: item.path };
    })
  });
};

exports.default = buildSitemap;